import styled from 'styled-components';
import StageOptionInput from '../StageOptionInput';

const ScoreInput = styled(StageOptionInput)`
  width: 100%;
  text-align: center;
`;

export default ScoreInput;
